import is from 'is_js';
import Privileges from 'domain/Privileges';
import { PrivilegeChecker } from 'omni-common-ui';
import ProgressTestRubricView, { mapStateToProps } from './component';
import StudentHorizontalSelect from '../StudentHorizontalSelect';

export default ({ getState }) => ({
  appBars: {
    sticky: {
      'student-select': {
        component: StudentHorizontalSelect,
        order: 2,
      },
    },
  },
  path: ':progressTestIndex/student/:studentId/skill/:skillIndex(/:mode)',
  view: 'student',
  component: ProgressTestRubricView,
  sessionNav: {
    noUnitSessionNavigation: true,
  },
  canAccess: (props) => {
    if (! ProgressTestRubricView.isInMarkingRoute(props)) {
      return true;
    }

    return PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressTest.Edit);
  },
  breadcrumbLabels: (props) => {
    const mappedProps = mapStateToProps(getState(), props);
    const { currentSkill } = mappedProps;
    const { params } = props;
    const segments = [currentSkill && currentSkill.name];
    if (params.mode === 'edit') segments.push('Edit');
    return segments;
  },
  actionButtons: {
    default: {
      Mark: {
        isPrimary: true,
        route: './edit',
        visibleWhen: ({ isMarkable, params }) => {
          const state = getState();
          const { groupId, studentId, progressTestIndex } = params;
          const hasPrivilege = PrivilegeChecker.hasPrivilege(state, Privileges.ProgressTest.Edit);
          const contentMap = state.get('rootReducer').get('contentMaps').get(groupId).data;
          const currentProgressTestId = contentMap
            .progressTests
            .get(progressTestIndex)
            .progressTestId;
          let currentProgressTest = state
            .get('rootReducer')
            .get('progressTests')
            .get(currentProgressTestId);
          if (currentProgressTest) {
            currentProgressTest = currentProgressTest.data;
          } else {
            // the progress test is unset; show the disabled button
            return true;
          }
          if (is.not.undefined(currentProgressTest)) {
            const currentStudentResult = currentProgressTest
              .studentProgressTestResults
              .get(studentId);
            return hasPrivilege && currentStudentResult.canBeOverwrite && isMarkable;
          }
          return hasPrivilege && isMarkable;
        },
        disableWhen: ({ params: { groupId, progressTestIndex } }) => {
          const state = getState();
          const contentMap = state.get('rootReducer').get('contentMaps').get(groupId).data;
          const currentProgressTestId = contentMap
            .progressTests
            .get(progressTestIndex)
            .progressTestId;
          const currentProgressTest = state
            .get('rootReducer')
            .get('progressTests')
            .get(currentProgressTestId);
          if (! currentProgressTest) {
            return true;
          }
          return false;
        },
      },
    },
    edit: {
      Save: {
        isPrimary: true,
        route: '../save',
      },
      Discard: {
        route: '../discard',
      },
    },
  },
});



// WEBPACK FOOTER //
// ./containers/Group/ProgressTest/ProgressTestRubricView/routes.js